module.exports = __webpack_public_path__ + "static/img/qqcode1.1f7ceee5.jpg";